import classNames from 'classnames'
import format from 'date-fns/format'
import { State } from 'index'
import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'styles/components/header.module.scss'
import text from 'styles/utility/text.module.scss'
import { HeaderNavMenuItem } from './index'
import { HorizontalLine, Spacer } from 'components/Utility'
import { getAuthShopRef, getBrandRef, getIsAdmin, getStoreRef } from 'reducks/auth/selectors'
import { adminMenus, ownerMenus } from 'constants/menus'
import { useIsAdminNotViewingStore } from 'hooks/auth'
import { getIsWebView } from 'lib/helper'
import { fetchPointCard } from 'reducks/pointCard/operations'
import { getPointCard } from 'reducks/pointCard/selectors'
import { fetchBrands } from 'reducks/brand/operations'

type Props = {
  handleMenuClose: () => void
}

const HeaderNavMenu: FC<Props> = (props) => {
  const { handleMenuClose } = props
  const dispatch = useDispatch()
  const brandRef = useSelector((state: State) => getBrandRef(state))
  const pointCard = useSelector((state: State) => getPointCard(state))
  const shopRef = useSelector((state: State) => getAuthShopRef(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const isAdminNotViewingStore = useIsAdminNotViewingStore(isAdmin, storeRef, shopRef)
  const isWebView = getIsWebView()

  useEffect(() => {
    if (!brandRef) return
    dispatch(fetchPointCard(brandRef))
  }, [brandRef])

  // 店舗切り替え時にブランドが必要なので取得する
  useEffect(() => {
    dispatch(fetchBrands())
  }, [])

  return (
    <nav className={styles.nav}>
      <ul className={styles.nav__list}>
        {ownerMenus.map((menu) => {
          const url = menu.url === '/order/' ? menu.url + format(new Date(), 'yyyyMMdd') : menu.url
          return (
            <HeaderNavMenuItem
              key={menu.label}
              childMenus={menu.childMenus}
              label={menu.label}
              handleMenuClose={handleMenuClose}
              icon={menu.icon}
              onClick={menu.onClick}
              requiredRole={menu.role}
              url={url}
            />
          )
        })}
        <HeaderNavMenuItem
          childMenus={
            pointCard
              ? [
                  { label: 'ポイント付与QRコード', url: '/point_card/code' },
                  { label: 'ポイント付与履歴', url: '/point_card/user' },
                ]
              : []
          }
          label={pointCard ? 'ポイントカード' : 'ポイントカードを作成する'}
          handleMenuClose={handleMenuClose}
          icon={'point_card'}
          requiredRole={9}
          url={pointCard ? '/point_card' : '/point_card/create'}
        />
        <HeaderNavMenuItem
          label={'店舗アカウント設定'}
          handleMenuClose={handleMenuClose}
          icon={'setting'}
          requiredRole={1}
          url={'/account'}
        />
        {isWebView && (
          <HeaderNavMenuItem
            label={'通知履歴'}
            handleMenuClose={handleMenuClose}
            icon={'push'}
            requiredRole={1}
            url={'/staffpush'}
          />
        )}
        {/* スーパー管理者用メニュー */}
        {isAdminNotViewingStore && (
          <>
            <Spacer size={16} />
            <h1 className={classNames(text.font_xxlarge, text.font_bold, text.color_grey_01)}>管理者設定</h1>
            <Spacer size={16} />
            <HorizontalLine verticalMargin={0} />
            {adminMenus.map((menu) => (
              <HeaderNavMenuItem
                key={menu.label}
                childMenus={menu.childMenus}
                label={menu.label}
                handleMenuClose={handleMenuClose}
                icon={menu.icon}
                requiredRole={menu.role}
                url={menu.url}
              />
            ))}
          </>
        )}
      </ul>
    </nav>
  )
}

export default HeaderNavMenu
